import type { ApiKeyAudience } from '../../lib/api-client';

const AUDIENCE_LABEL: Record<ApiKeyAudience, string> = {
  mcp: 'MCP',
  direct_api: 'Direct API',
  openai_completions: 'OpenAI',
  integration: 'Integration',
};

const PALETTE: Record<ApiKeyAudience, { bg: string; fg: string }> = {
  mcp: { bg: 'rgba(197, 107, 69, 0.12)', fg: '#b55a37' },
  direct_api: { bg: 'rgba(110, 130, 160, 0.15)', fg: '#3a4a60' },
  openai_completions: { bg: 'rgba(72, 160, 130, 0.15)', fg: '#2f7a5e' },
  integration: { bg: 'rgba(140, 100, 180, 0.14)', fg: '#6b4a99' },
};

// A key with an audience this build doesn't know must render, not white-screen
// the workspace (keys are minted server-side and can outrun the UI).
const FALLBACK = { bg: 'rgba(110, 130, 160, 0.15)', fg: '#3a4a60' };

/** Small colored chip naming a key's protocol (audience). */
export function AudienceBadge({ audience }: { audience: ApiKeyAudience }) {
  const { bg, fg } = PALETTE[audience] ?? FALLBACK;
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        background: bg,
        color: fg,
        letterSpacing: 0.2,
      }}
    >
      {AUDIENCE_LABEL[audience] ?? audience}
    </span>
  );
}
